<script>
import { mapGetters } from 'vuex'
import TermsOfServiceLink from './TermsOfServiceLink.vue'
import VoucherBalanceForm from './VoucherBalanceForm.vue'
import LangSwitcher from './LangSwitcher.vue'

export default {
    name: 'Footer',
    components: { TermsOfServiceLink, VoucherBalanceForm, LangSwitcher },
    computed: {
        ...mapGetters(['userResource']),
        year() {
            return new Date().getFullYear()
        },
    },
}
</script>

<template>
    <footer class="footer-main" v-if="$route.query.nav !== 'false'">
        <b-container class="pt-5 pb-5">
            <b-row>
                <b-col sm="12">
                    <div class="happy mb-3">
                        <b-link href="https://shiftos.app" target="_blank">Felices carreras.</b-link>
                    </div>
                </b-col>
                <b-col>
                    <ul class="list-unstyled">
                        <li><terms-of-service-link text="Términos del servicio" /></li>
                        <li v-if="$store.getters.userId"><router-link :to="{ name: 'change_password' }">Cambiar contraseña</router-link></li>
                        <li v-else><router-link :to="{ name: 'forgot_password' }">Olvidé mi contraseña</router-link></li>
                        <li v-if="!$store.getters.userId"><router-link :to="{ name: 'signup' }">Crear una cuenta</router-link></li>
                        <li v-if="!$store.getters.userId"><router-link :to="{ name: 'login' }">Iniciar sesión</router-link></li>
                        <li v-else>
                            <router-link :to="{ name: 'logout' }">Cerrar sesión ({{ userResource }})</router-link>
                        </li>
                        <li><lang-switcher /></li>
                    </ul>
                </b-col>
                <b-col>
                    <ul class="list-unstyled">
                        <li><router-link :to="{ name: 'purchaseVoucher' }">Comprar un vale de regalo</router-link></li>
                        <li><a href="javascript:{}" @click="$refs.balanceModal.show()">Saldo del vale</a></li>
                        <li><router-link :to="{ name: 'leaderboards' }">Clasificaciones</router-link></li>
                        <li>&copy; {{ year }} {{ $appConfig('COMPANY_NAME', 'ShiftOS') }}</li>
                    </ul>
                </b-col>
            </b-row>
        </b-container>

        <!-- Modals-->
        <b-modal ref="balanceModal" size="md" title="Saldo del código del vale" hide-footer no-fade centered>
            <voucher-balance-form />
        </b-modal>
    </footer>
</template>

<style lang="scss">
footer.footer-main {
    background: var(--sos-bg);
    border-top: 1px solid var(--sos-border);
    font-size: 0.78rem;
    font-weight: 400;
    color: var(--sos-ink-mute);

    a {
        color: var(--sos-link);

        &:hover {
            color: var(--sos-link);
            text-decoration: underline;
        }
    }

    ul.list-unstyled {
        text-align: right;

        li {
            margin-bottom: 0.4rem;
        }
    }

    .happy {
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 1.1rem;
        text-transform: uppercase;
        font-weight: 700;
        font-family: var(--sos-font-head);
        color: var(--sos-ink-strong);
        text-align: left;

        &::before {
            content: '';
            flex: none;
            width: 32px;
            height: 4px;
            background: linear-gradient(90deg, var(--red) 0 55%, transparent 55% 66%, var(--teal) 66% 100%);
            transform: skewX(-18deg);
        }

        a {
            color: var(--sos-ink-strong);
            font-style: italic;
        }
    }
}

@media (max-width: 768px) {
    // footer {
    //     display: none;
    // }
    footer.footer-main {
        ul.list-unstyled {
            text-align: center;
        }

        .happy {
            justify-content: center;
        }
    }
}
</style>
